<template>
  <div>
    <topback title="KYC Verify" path="back">
    </topback>

    <md-field class="mt-6 mb-3">

      <md-field-item>
        <div class="md-example-child md-example-child-reader md-example-child-reader-0">
          <ul class="image-reader-list">
            <li class="image-reader-item" v-if="frontimage !== ''"
              :style="{ 'backgroundImage': `url(${frontimage})`, 'backgroundPosition': 'center center', 'backgroundRepeat': 'no-repeat', 'backgroundSize': 'cover' }">
              <md-tag class="image-reader-item-del" size="small" shape="quarter" fill-color="#111A34" type="fill"
                font-color="#fff" @click.native="onDeleteImage('frontimage')" v-if="this.isshowbtn">
                <md-icon name="close"></md-icon>
              </md-tag>
            </li>
            <li class="image-reader-item add" v-if="frontimage === ''">
              <md-image-reader name="frontimage" @select="onReaderSelect" @complete="onReaderComplete"
                @error="onReaderError" is-multiple></md-image-reader>
              <md-icon name="camera" size="md" color="#CCC"></md-icon>
              <p>Upload</p>
            </li>
          </ul>
        </div>
        <p class="childrens" slot="children">Please upload front image file</p>
      </md-field-item>
    </md-field>

    <md-field class="mt-6 mb-3">
      <md-field-item>
        <div class="md-example-child md-example-child-reader md-example-child-reader-0">
          <ul class="image-reader-list">
            <li class="image-reader-item" v-if="backimage !== ''"
              :style="{ 'backgroundImage': `url(${backimage})`, 'backgroundPosition': 'center center', 'backgroundRepeat': 'no-repeat', 'backgroundSize': 'cover' }">
              <md-tag class="image-reader-item-del" size="small" shape="quarter" fill-color="#111A34" type="fill"
                font-color="#fff" @click.native="onDeleteImage('backimage')" v-if="this.isshowbtn">
                <md-icon name="close"></md-icon>
              </md-tag>
            </li>
            <li class="image-reader-item add" v-if="backimage === ''">
              <md-image-reader name="backimage" @select="onReaderSelect" @complete="onReaderComplete"
                @error="onReaderError" is-multiple></md-image-reader>
              <md-icon name="camera" size="md" color="#CCC"></md-icon>
              <p>Upload</p>
            </li>
          </ul>
        </div>
        <p class="childrens" slot="children">Please upload reverse side image file</p>
      </md-field-item>
      
      <div class="md-example-child md-example-child-image-reader" v-if="this.isshowbtn">
        <p class="childrens" style="text-align: left; ">example:</p>
        <div>
          <ul>
            <template v-for="(item, index) in imgs">
              <li @click="showViewer(index, $event)" :key="index">
                <div class="img" :style="`background: url(${item}) center no-repeat;background-size:cover;`">
                </div>
              </li>
            </template>
          </ul>
        </div>
        <md-image-viewer v-model="isViewerShow" :list="imgs" :has-dots="true" :initial-index="viewerIndex">
        </md-image-viewer>
      </div>


      <div style="margin-top: 1rem; color: red;">
        <p class="childrens">Status: {{ this.$store.state.userinfo.kyc }}</p>
      </div>
    </md-field>
    <md-button class="fixed-buttom" type="primary" round @click="uploadkyc"
      v-if="this.isshowbtn && this.$store.state.userinfo.kyc === 'notcertified'">UpLoad</md-button>
    <md-button class="fixed-buttom" type="primary" round @click="modifykyc" v-else-if="this.isshowbtn">UpLoad</md-button>
  </div>
</template>

<script>
import topback from '@/components/topback'
import iconimg from '@/components/iconimg'
import { ImageViewer } from 'mand-mobile'
import { Dialog, Icon, ImageReader, Tag, Toast } from 'mand-mobile'
import { uploadimage, cwkyc, getcwkyc, modifykyc } from '@/request/api'

export default {
  name: 'kycpartner',
  components: {
    [ImageViewer.name]: ImageViewer,
    topback,
    iconimg
  },

  data() {
    return {
      cwkycid: 0,
      isshowbtn: false,
      frontimage: "",
      backimage: "",
      isViewerShow: false,
      viewerIndex: 0,
      imgs: [
        '../static/images/kyc_positive.png',
        '../static/images/kyc_negative.png'
      ],
    }
  },
  created() {
    this.$store.dispatch("asyncupdatesiteconfig");
    this.isshowbtn = this.$store.state.userinfo.kyc === 'notcertified' || this.$store.state.userinfo.kyc === 'reject';
    if (this.$store.state.userinfo.kyc !== 'notcertified') {
      this.getcwkycimg();
    }
  },
  methods: {
    showViewer(index) {
      this.viewerIndex = index
      this.isViewerShow = true
    },
    onReaderSelect(name, { files }) {
      files.forEach(file => {
        console.log('[Mand Mobile] ImageReader Selected:', 'File Name ' + file.name)
      })
      Toast.loading('picture reading...')
    },
    onReaderComplete(name, { dataUrl, file }) {
      this.$toast.loading('Uploading...');
      uploadimage({ imagedata: dataUrl }).then((res) => {
        console.log("name", name);
        this.$toast.hide();
        if (res.code === 200) {
          console.log("imgurl", res.data.imgurl);
          if (name === "frontimage") {
            this.frontimage = this.$store.state.siteconfig.ApiUrl.substr(0, this.$store.state.siteconfig.ApiUrl.length - 1) + res.data.imgurl;
          }
          else if (name === "backimage") {
            this.backimage = this.$store.state.siteconfig.ApiUrl.substr(0, this.$store.state.siteconfig.ApiUrl.length - 1) + res.data.imgurl;
          }
        }
        else {
        }
      }).catch(() => {
        this.$toast.hide();
      });
    },
    onReaderError({ msg }) {
      Toast.failed(msg)
    },
    onDeleteImage(filename) {
      if (filename === 'frontimage') {
        this.frontimage = '';
      }
      else if (filename === 'backimage') {
        this.backimage = '';
      }
    },
    uploadkyc() {
      let that = this;
      if (that.frontimage === "" || that.backimage === "") {
        that.$toast.failed('Please upload the front of the ID card');
        return;
      }
      cwkyc({ kyc_positive: that.frontimage, kyc_negative: that.backimage }).then((res) => {
        if (res.code === 200) {
          that.$toast.succeed('Upload success');
          that.$router.push("/my");
        }
        else {
          that.$toast.failed(res.msg);
        }
      }).catch(() => {
        that.$toast.hide();
      });
    },
    modifykyc() {
      let that = this;
      if (that.frontimage === "" || that.backimage === "") {
        that.$toast.failed('Please upload the front of the ID card');
        return;
      }
      modifykyc({ id: that.cwkycid, kyc_positive: that.frontimage, kyc_negative: that.backimage }).then((res) => {
        if (res.code === 200) {
          that.$toast.succeed('Upload success');
          that.$router.push("/my");
        }
        else {
          that.$toast.failed(res.msg);
        }
      }).catch(() => {
        that.$toast.hide();
      });

    },
    getcwkycimg() {
      getcwkyc().then((res) => {
        if (res.code === 200) {
          this.frontimage = res.data.kyc_positive;
          this.backimage = res.data.kyc_negative;
          this.cwkycid = res.data.id;
        }
        else {
          this.$toast.failed(res.msg);
        }
      }).catch(() => {
        this.$toast.hide();
      });
    }
  }
}

</script>
<style scoped>
.fixed-buttom {
  position: fixed;
  bottom: 0.3rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
}

.partner .selector-header,
.partner .selector-footer {
  padding: 15px 40px;
  font-size: 16px;
  color: #ccc;
}

.partner .selector-item-body {
  display: flex;
  align-items: center;
}

.partner .selector-item-body.selected .selector-item-content {
  color: #2f86f6;
}

.partner .selector-item-body.disabled {
  opacity: .3;
}

.partner .selector-item-body .selector-item-left {
  flex-shrink: 0;
  margin-right: 32px;
}

.partner .selector-item-body .selector-item-left .holder {
  display: block;
  width: 88px;
  height: 88px;
  border-radius: 44px;
  background-color: #e6e6e6;
  font-size: 32px;
  font-weight: 500;
  color: #2f86f6;
  text-align: center;
  line-height: 88px;
}

.partner .selector-item-body .selector-item-content {
  flex: 1;
  color: #111a34;
  font-size: 32px;
  line-height: 1.2;
}

.partner .selector-item-body .selector-item-content .selector-item-title {
  line-height: 1.2;
}

.partner .selector-item-body .selector-item-content .selector-item-brief {
  color: #858b9c;
  font-size: 24px;
  line-height: 1.4;
  margin-top: 8px;
}


.md-example-child-reader .image-reader-list {
  float: left;
  width: 100%;
}

.md-example-child-reader .image-reader-list .image-reader-item {
  position: relative;
  width: 35%;
  padding-bottom: 35%;
  margin-bottom: 2%;
  margin-right: 2%;
  background: #fff;
  box-shadow: 0 5px 20px rgba(197, 202, 213, 0.25);
  box-sizing: border-box;
  list-style: none;
  border-radius: 4px;
  background-size: cover;
  overflow: hidden;
  margin: 0 auto;
}

.md-example-child-reader .image-reader-list .image-reader-item:nth-of-type(4n) {
  margin-right: 0;
}

.md-example-child-reader .image-reader-list .image-reader-item.add .md-icon {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.5;
}

.md-example-child-reader .image-reader-list .image-reader-item.add p {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  margin-top: 15px;
  font-size: 22px;
  color: #ccc;
  text-align: center;
}

.md-example-child-reader .image-reader-list .image-reader-item .image-reader-item-del {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 3;
  opacity: 0.8;
}

.md-example-child-reader .image-reader-list .image-reader-item .image-reader-item-del .md-icon-close {
  font-size: 24px;
}

.childrens {
  text-align: center;
  font-size: 0.3rem;
}
</style>
<style lang="stylus" scoped>
.md-example-child-image-reader
  float left
  margin-top 0.3rem
  margin-bottom 0.3rem
  width 100%
  ul
    float left
    width 100%
    li
      position relative
      float left
      width 22%
      padding-bottom 22%
      margin-left 2%
      margin-top 2%
      border-sizing border-box
      border-radius 2px
      overflow hidden
      list-style none
      .img
        position absolute
        width 100%
        height 100%
</style>


// WEBPACK FOOTER //
// src/views/my/kycverify.vue